// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","1200":"(min-width: 1200px)","root":"UJt_IlSfXS8TqbzQA4nC","details":"OM3ucUSil76fUXcd3BzV","name":"xQREZqxItTPauiqwwho2","link":"LdKCn6jBSWobAP6jVLWx"};